// extracted by mini-css-extract-plugin
export default {"settings":"ZhMyp0GizHogsxgNwFBZ","container":"pNgeIrt7jclDe36R8OpE"};